import { render, staticRenderFns } from "./ReceiptCard.vue?vue&type=template&id=6ffec8b0&scoped=true"
import script from "./ReceiptCard.vue?vue&type=script&lang=ts"
export * from "./ReceiptCard.vue?vue&type=script&lang=ts"
import style0 from "./ReceiptCard.vue?vue&type=style&index=0&id=6ffec8b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffec8b0",
  null
  
)

export default component.exports